module.exports = __webpack_public_path__ + "static/media/hat_c.8f6b5a1d.ogg";